import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Content Categories with colors
export const CATEGORY_STYLES = {
  "Education / Trust": { bg: "bg-blue-50", text: "text-blue-700", dot: "bg-blue-500" },
  "Product Showcase (Bling)": { bg: "bg-amber-50", text: "text-amber-700", dot: "bg-amber-500" },
  "Offers / Urgency": { bg: "bg-red-50", text: "text-red-700", dot: "bg-red-500" },
  "Custom / Process": { bg: "bg-indigo-50", text: "text-indigo-700", dot: "bg-indigo-500" },
  "Social Proof": { bg: "bg-emerald-50", text: "text-emerald-700", dot: "bg-emerald-500" },
  "Founder / BTS / Lifestyle": { bg: "bg-purple-50", text: "text-purple-700", dot: "bg-purple-500" },
  "Fun / Trend / Meme": { bg: "bg-orange-50", text: "text-orange-700", dot: "bg-orange-500" },
  "AI Pink Cow": { bg: "bg-pink-50", text: "text-pink-700", dot: "bg-pink-500" },
};

export const getCategoryStyle = (category) => {
  return CATEGORY_STYLES[category] || { bg: "bg-zinc-100", text: "text-zinc-700", dot: "bg-zinc-500" };
};

// Priority styles
export const PRIORITY_STYLES = {
  "P0": { bg: "bg-red-50", text: "text-red-700" },
  "P1": { bg: "bg-amber-50", text: "text-amber-700" },
  "P2": { bg: "bg-blue-50", text: "text-blue-700" },
};

export const getPriorityStyle = (priority) => {
  return PRIORITY_STYLES[priority] || { bg: "bg-zinc-100", text: "text-zinc-700" };
};

// Status styles
export const STATUS_STYLES = {
  "Backlog": { bg: "bg-zinc-100", text: "text-zinc-600" },
  "Shortlisted": { bg: "bg-blue-50", text: "text-blue-700" },
  "Greenlit": { bg: "bg-emerald-50", text: "text-emerald-700" },
  "In Production": { bg: "bg-amber-50", text: "text-amber-700" },
  "Scheduled": { bg: "bg-indigo-50", text: "text-indigo-700" },
  "Posted": { bg: "bg-emerald-100", text: "text-emerald-800" },
  "Archived": { bg: "bg-zinc-100", text: "text-zinc-500" },
  "Captured": { bg: "bg-zinc-100", text: "text-zinc-600" },
  "Reviewed": { bg: "bg-emerald-50", text: "text-emerald-700" },
};

export const getStatusStyle = (status) => {
  return STATUS_STYLES[status] || { bg: "bg-zinc-100", text: "text-zinc-700" };
};

// Format date
export const formatDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  return date.toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
};

// Format relative time
export const formatRelativeTime = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);
  
  if (diffInSeconds < 60) return "Just now";
  if (diffInSeconds < 3600) return `${Math.floor(diffInSeconds / 60)}m ago`;
  if (diffInSeconds < 86400) return `${Math.floor(diffInSeconds / 3600)}h ago`;
  if (diffInSeconds < 604800) return `${Math.floor(diffInSeconds / 86400)}d ago`;
  
  return formatDate(dateString);
};

// Truncate text
export const truncateText = (text, maxLength = 100) => {
  if (!text || text.length <= maxLength) return text;
  return text.substring(0, maxLength) + "...";
};
